import { useContext } from "react";
import { AppContext } from "../../../../../common/contexts/app_context/app_context";
import { useLoginViewModel } from "../../viewModels/login_view_model";
import { Logo } from "../../../../../common/components/logo";
import { LogoWhite } from "../../../../../common/components/logo_white";
import { Alert } from "@mui/material";
import { Iso } from "../../../../../common/components/iso";
import { EsqueceuSuaSenhaModal } from "./components/esqueceu_sua_senha_modal";
import { TrocarSenhaModal } from "./components/trocar_senha_modal";

import PasswordInput from "../../../../../common/components/password_input";
import ThemeSwitch from "../../../../../common/components/theme_switch";
import PrimaryButton from "../../../../../common/components/primary_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";

const OutubroRosaRibbonIcon = ({ className }: any) => (
  <svg viewBox="0 0 100 120" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Estrutura do laço com cor rosa-400 (pink-400) e rosa-500 (pink-500) */}
    <path d="M30,110 C30,110 70,50 70,30 C70,10 30,10 30,30 C30,50 70,110 70,110" stroke="#F472B6" strokeWidth="14" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * Login
 */

export const Login = () => {
  const { theme, toggleTheme } = useContext(AppContext);
  const viewModel = useLoginViewModel();

  return (
    <>
      <div className="w-screen lg:h-screen flex items-center justify-between flex-col lg:px-1 lg:flex-row-reverse overflow-scroll-y bg-light-mode-2 dark:bg-dark-mode-2">
        {/* Painel de Login (Lado Direito na UI Desktop) */}
        <div className="min-h-screen w-full lg:h-[99%] lg:w-2/5 px-[5%] p-12 lg:pb-4 items-center justify-center overflow-clip lg:overflow-y-scroll">
          <div className="w-full h-full flex flex-col items-center justify-between">
            <div className="w-full flex flex-row justify-between">
              {/* Destinado para Alertas */}
              {/* <p
                className="text-[#f97316] text-base font-bold mr-16"
                style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 1)' }}>
                No dia 29/06/2026,<br />
                o suporte via WhatsApp será de 08:00 as 12:00.
              </p> */}

              <ThemeSwitch
                label={false}
                theme={theme}
                toggleTheme={toggleTheme}
              />
            </div>

            <div className="2xl:w-[400px] mt-8 lg:mt-0">
              {false && (
                <>
                  <div className="w-full">
                    <Logo />
                  </div>
                </>
              )}
              <div className="flex justify-center mb-12 w-full">
                {/* Ícone de Laço - Outubro Rosa (Tom médio) */}
                <div className="size-[8rem]">
                  <OutubroRosaRibbonIcon />
                </div>
                {/*<Logo />*/}
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 120"
                  className="w-24 h-auto opacity-90 transition-transform hover:scale-105 duration-300 drop-shadow-lg text-pink-500"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="14"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M30,110 C30,110 70,50 70,30 C70,10 30,10 30,30 C30,50 70,110 70,110" />
                </svg> */}
              </div>

              <div className="text-black dark:text-white font-semibold w-full mt-14 lg:mt-8">
                <h1 className="">
                  Bem-vindo ao
                  <span className="text-pink-500 dark:text-pink-400">
                    {" Sistema SGQ"} 🎀
                  </span>
                </h1>

                <h1 className="text-4xl">Login</h1>

                <div className="w-full mt-6 mb-4">
                  <h1 className="font-semibold text-black dark:text-white">
                    Informe os dados abaixo
                  </h1>
                </div>

                <form
                  className="w-full min-w-[20rem] flex gap-4 flex-col items-center justify-center"
                  onSubmit={viewModel.handleSubmit}
                >
                  <DefaultFormInput
                    name={"login"}
                    fullWidth={true}
                    label="Login"
                    reactHookForm={viewModel.hookForm}
                  />

                  <PasswordInput
                    label="Senha"
                    error={viewModel.errors.password !== undefined}
                    helperText={
                      viewModel.errors.password &&
                      viewModel.errors.password.message
                    }
                    reactHookForm={viewModel.hookForm.register("password")}
                  />

                  <div className="w-full flex justify-start mb-8">
                    <p
                      className="text-sm text-pink-500 dark:text-pink-400 font-medium cursor-pointer hover:underline"
                      onClick={() => viewModel.handleTrocarSenhaOpenState(true)}
                    >
                      Trocar senha
                    </p>
                  </div>

                  <div className="w-full flex flex-col gap-2 items-center">
                    {/* Botão com gradiente rosa médio */}
                    <button
                      type="submit"
                      disabled={viewModel.isSubmitting}
                      className="w-full bg-gradient-to-r from-pink-400 via-pink-500 to-pink-400 hover:from-pink-500 hover:to-pink-600 text-white font-bold py-3.5 rounded-lg mt-4 transition-all transform hover:scale-[1.02] shadow-lg shadow-pink-500/40 text-lg disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {viewModel.isSubmitting ? "Autenticando..." : "Entrar"}
                    </button>

                    <div
                      onClick={() =>
                        viewModel.handleEsqueceuSuaSenhaModalOpenState(true)
                      }
                    >
                      <p className="text-sm text-pink-500 dark:text-pink-400 font-medium cursor-pointer mt-2 hover:underline">
                        Esqueceu sua senha?
                      </p>
                    </div>
                  </div>
                  {viewModel.errors.root && (
                    <Alert severity="error">
                      {viewModel.errors.root.message}
                    </Alert>
                  )}
                </form>

                <div className="my-8 w-full flex items-center justify-end flex-col text-sm text-center text-black dark:text-white">
                  {false && (
                    <>
                      <p className="font-semibold">
                        Possui um login no antigo sistema da GDOL?
                      </p>
                      <p>Configure agora seu primeiro acesso no novo sistema</p>
                      <div className="w-1/2 mt-4">
                        <PrimaryButton
                          onClick={viewModel.handleConfigure}
                          buttonColor={
                            theme === "light" ? "secondary" : "secondary-white"
                          }
                        >
                          Configurar
                        </PrimaryButton>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <h1 className="text-[12px] text-center text-black dark:text-white">
              @SGQ Sistema de Gestão de Qualidade | Todos os Direitos Reservados
            </h1>
          </div>
        </div>

        {/* Painel Temático Outubro Rosa (Lado Esquerdo na UI Desktop) - TOM MÉDIO */}
        <div className="h-screen w-full mb-1 lg:mb-0 lg:h-[99%] lg:w-3/5 relative overflow-hidden bg-pink-500 rounded-sm">
          {/* Fundo Gradiente Rosa Médio */}
          <div className="absolute inset-0 bg-gradient-to-br from-pink-400 via-pink-500 to-pink-600"></div>

          {/* Elementos Decorativos */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-white/10 rotate-45 transform origin-center transition-transform hover:scale-105 duration-700"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-300/30 rounded-full blur-3xl"></div>
          <div className="absolute inset-0 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:24px_24px] opacity-[0.15]"></div>

          <div className="relative z-10 flex flex-col justify-between w-full px-12 py-8 h-full text-white">
            <div className="w-full flex items-center lg:items-start justify-center lg:justify-start">
              <LogoWhite />
            </div>

            <div className="text-center transform -translate-y-10 flex flex-col items-center">
              {/* Selo Outubro Rosa */}
              {/*<div className="inline-block bg-white/20 px-6 py-1.5 rounded-full text-sm font-bold mb-6 backdrop-blur-sm border border-white/30 shadow-sm text-white">
                🎀 Apoiamos o Outubro Rosa
              </div>*/}
              <h1 className="text-4xl font-black text-white mb-4 drop-shadow-xl tracking-wider italic">
                Acelere os seus resultados com o Sistema SGQ
              </h1>
            </div >

            {/* Logo ISO Original */}
            < div className="w-full flex items-end justify-center" >
              <Iso />
            </div >
          </div >
        </div >
      </div >

      {/**
       * Modals
       */}

      < EsqueceuSuaSenhaModal
        open={viewModel.esqueceuSuaSenhaModal}
        saving={viewModel.saving}
        infoMessage={viewModel.infoMessage}
        errorMessage={viewModel.errorMessage}
        hookForm={viewModel.esqueceuSuaSenhaHookForm}
        onClose={() => viewModel.handleEsqueceuSuaSenhaModalOpenState(false)}
        onSubmit={viewModel.handleEsqueceuSuaSenhaSubmit}
      />

      <TrocarSenhaModal
        open={viewModel.trocarSenhaModal}
        saving={viewModel.saving}
        successMessage={viewModel.trocaSenhaInfoMessage}
        hookForm={viewModel.trocarSenhaHookForm}
        onClose={() => viewModel.handleTrocarSenhaOpenState(false)}
        onSubmit={viewModel.handleTrocarSenhaSubmit}
      />
    </>
  );
};